module.exports = __webpack_public_path__ + "img/home_1.fdce5173.jpg";